// extracted by mini-css-extract-plugin
export var active = "_gn-2";
export var recordingDot = "_gn-1";
export var recordingIndicator = "_gn-0";